<template>
  <div v-if="showOldMenu()">

    <SignOutDialog v-show="showSignOut" @close="closeSignOutDialog" />

    <v-row v-if="false">
      <v-col :cols="12">
        <AppMenu :isSmall="true" />
      </v-col>
    </v-row>

    <v-row v-if="hasCompany">
      <v-col v-if="isAdmin" :cols="1" class="rc-text-centre">
        Administration Portal
      </v-col>
      <v-col v-else :cols="1"></v-col>

      <v-col :cols="10">
        <div :showBorder="true">
          <v-row>
            <v-col :cols="2" class="rc-text-left">
              <div style="padding-top: 5px;">
                <img src="@/assets/2019/circlechek_logo.png" style="height: 40px;">
              </div>
            </v-col>

            <v-col :cols="6" class="rc-text-centre">
              <div style="padding-top: 10px;">
                <div class="rc-text-xlarge">
                  <a v-if="hasCompanys" class="clickable" v-on:click="withButtonPressed({ field: 'select' })">{{
                    companyName
                    }}</a>
                  <div v-else>{{ CU.decodeText(companyName) }} </div>
                </div>
              </div>
            </v-col>

            <v-col :cols="2" class="rc-text-right" v-if="isApril2026OrAfter()">
              <div style="padding-top: 14px;">
                <span v-on:click="withButtonPressed({ field: 'newPortal' })" class="clickable"
                  style="background-color: #009436;color: white; border-radius: 5px; padding: 5px;">Try our NEW
                  Portal</span>
              </div>
            </v-col>
            <v-col v-else :cols="2">
            </v-col>

            <v-col :cols="2" class="mt-5">
              <div class="d-flex align-center mr-2">
                <span class="text-body-2 mr-2 d-none d-sm-flex">Hi, {{ first() }}!</span>
                <v-menu location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-btn icon v-bind="props">
                      <img v-if="isDec()" src="@/v3/assets/2025/SantaHatProfile1.png" width="35" />
                      <v-icon v-else size="large">mdi-account-outline</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item v-for="item in profileMenuItems()" :key="item.value" @click="handleMenuClick(item.value)"
                      :prepend-icon="item.icon">
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row> <!-- v-row -->

    <v-row v-if="showMenu">
      <v-col :cols="12">
        <AppPortalMenu />
      </v-col>
    </v-row>

  </div><!-- OldMenu Container -->
</template>

<script>

import { mapGetters } from 'vuex';
import AppPortalMenu from './AppPortalMenu.vue';
import ContentUtils from '@/utils/ContentUtils.js';
import StringUtils from '@/utils/StringUtils.js';
import SignOutDialog from "@/portals/customer/operator/views/sign/out/SignOutDialog.vue";
import RcTime from '@/domain/session/time/RcTime';
import ConstUtils from '@/utils/ConstUtils.js';
import AppMenu from './AppMenu.vue';

export default {
  name: 'app-header',
  components: {
    AppMenu,
    AppPortalMenu,
    SignOutDialog,
  },
  data() {
    return {
      Consts: ConstUtils,
      CU: ContentUtils,
      connected: false,
      hasCompany: false,
      companyName: null,
      isAdmin: false,
      isProduction: true,
      showSignOut: false,
      dialog: null,
      isNew: false,
    };
  },
  computed: {
    ...mapGetters([
      'user_roles',
      'auth_client',
      'auth_connected',
      'auth_user',
      'AuthStorage_Company',
      'domain',
    ]),
    isConnected: function () {
      return this.connected;
    },
    hasCompanys: function () {
      var user = this.domain.session().user();
      var employees = this.domain.employees().findByUserId(user.id());
      return employees.length() > 1;
    },
    showMenu() {
      console.log("company, isNew", this.hasCompany, this.isNew);
      return this.hasCompany && !this.isNew;
    }
  },
  watch: {
    auth_connected() {
      if (!this.auth_connected) {
        this.$connect();
      }
    },

    AuthStorage_Company() {
      if (this.AuthStorage_Company) {
        this.companyName = this.AuthStorage_Company.name();
        this.hasCompany = true;
        this.isNew = this.AuthStorage_Company.isNew();
      } else {
        this.companyName = null;
        this.hasCompany = false;
      }
      this.isAdmin = this.domain.session().employee().find().roles().find().isAdministrator();
      this.isProduction = !this.auth_client.debug;
    },
  },
  mounted: function () {
    this.isProduction = !this.auth_client.debug;
  },
  methods: {
    isDec() {
      let rcTime = RcTime.time();
      let now = rcTime.now();
      if (now.month().value() == 11) {
        return true;
      }
      return false;
    },

    decode: function (value) {
      return ContentUtils.unescape(value);
    },
    first: function () {
      if (!this.domain || !this.domain.session()) {
        return "";
      }
      var name = this.domain.session().user().firstDisplay();
      return name;
    },
    email: function () {
      if (!this.domain || !this.domain.session()) {
        return "";
      }
      return this.domain.session().user().emailDisplay();
    },
    profileMenuItems: function() {
      return [
        { title: 'Profile', icon: 'mdi-account-circle-outline', value: 'profile', requiresRole: 'default', version: 'v3' },
        { title: 'Sign Out', icon: 'mdi-logout', value: 'signOut', requiresRole: 'default', version: '' },
      ]
    },
    showOldMenu: function () {
      return true;
    },
    signout: function () {
      this.showSignOut = true;
    },
    closeSignOutDialog: function (buttonData) {
      this.showSignOut = false;
      if (buttonData) {
        this.$router.replace({ name: ConstUtils.ROUTES.SIGNIN });
      }
    },
    withButtonPressed(buttonData) {
      if (!buttonData) {
        return;
      }
      if (buttonData["field"] == "profile") {
        let operatorId = this.domain.session().company().idEncoded();
        let userId = this.domain.session().user().idEncoded();
        window.console.log(JSON.stringify(buttonData, null, 2));
        let newPath = "/portal/operator/" + operatorId + "/users/" + userId + "/profile";
        // let newPath = "/portal/" + path;
        this.$router.push({ path: newPath })

      } else if (buttonData["field"] == "newPortal") {
        localStorage.setItem('v3', 'true');
        let path = ConstUtils.ROUTES.DASHBOARD_PATH;
        if (this.isAdmin) {
          path = ConstUtils.ROUTES.V3.ADMIN.HOME.PATH;
        }
        const homePath = StringUtils.format(path, [this.domain.session().company().idEncoded()]);
        this.$router.push({ path: homePath })
          .then(() => {
            window.location.reload();
          })
          .catch(err => {
            console.error("Navigation error during V3 toggle:", err);
            window.location.reload();
          });
      } else {
        let newPath = "/portal/operator/companys";
        this.$router.push({ path: newPath });
      }
    },

    isApril2026OrAfter() {
      return true;
    },

    handleMenuClick(action) {
      if (action === 'profile') {
        this.withButtonPressed({ field: 'profile'});
      } else if (action === 'signOut') {
        this.signout();
      }
    },
  },
}

</script>